import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import GamingPage from "../pages/gaming/GamingPage";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../pages/gaming/IntegrationOptions";
import Benefits from "../pages/gaming/Benefits";

const Gaming = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <GamingPage />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default Gaming;
